/* eslint-disable camelcase */
import i18n from 'i18next';

import getVideoAdminPropertiesAdditionalDetailsSchema from '../schemas/getVideoAdminPropertiesAdditionalDetailsSchema';
import getVideoAdminPropertiesCatalogPropertiesSchema from '../schemas/getVideoAdminPropertiesCatalogPropertiesSchema';
import getVideoAdminPropertiesCustomFieldsSchema from '../schemas/getVideoAdminPropertiesCustomFieldsSchema';
import getVideoAdminPropertiesDisplaySchema from '../schemas/getVideoAdminPropertiesDisplaySchema';
import getVideoAdminPropertiesGeneralSchema from '../schemas/getVideoAdminPropertiesGeneralSchema';
import getVideoAdminPropertiesSeoPropertiesSchema from '../schemas/getVideoAdminPropertiesSeoPropertiesSchema';
import getVideoAdminPropertiesSocialSchema from '../schemas/getVideoAdminPropertiesSocialSchema';
import getVideoAdminPropertiesTaggingSchema from '../schemas/getVideoAdminPropertiesTaggingSchema';
import getVideoAdminPropertiesVideoSchema from '../schemas/getVideoAdminPropertiesVideoSchema';

export default ({ adminSettings, id, isInLiveMode, videoProperties, videoPropertiesKey }) => {
  const { is_active, name, caption, is_locale_master } = getVideoAdminPropertiesGeneralSchema({
    isInLiveMode,
  });
  const { replaceVideo } = getVideoAdminPropertiesVideoSchema({
    label: i18n.t('file-upload'),
    help: '',
    videoProperties,
    videoPropertiesKey,
  });
  const { cover_art } = getVideoAdminPropertiesDisplaySchema();
  const { exclude_from_search, topics, topic, summary } =
    getVideoAdminPropertiesCatalogPropertiesSchema({
      isInLiveMode,
      videoProperties,
      videoPropertiesKey,
    });
  const { community_enabled, tribe_chat_enabled } = getVideoAdminPropertiesSocialSchema({
    adminSettings,
    isInLiveMode,
  });
  const { tags } = getVideoAdminPropertiesTaggingSchema({});
  const topicsKey = isInLiveMode ? 'topic' : 'topics';
  const topicsMap = { topic, topics };

  return [
    {
      title: i18n.t('general'),
      schema: {
        ...(!isInLiveMode && {
          is_active: {
            ...is_active,
            options: [
              { value: true, label: i18n.t('active') },
              { value: false, label: i18n.t('inactive') },
            ],
          },
        }),
        ...(isInLiveMode && {
          status,
        }),
        name,
        caption: {
          ...caption,
          options: {
            type: 'file',
          },
        },
        is_locale_master: {
          ...is_locale_master,
          options: [
            { value: true, label: i18n.t('active') },
            { value: false, label: i18n.t('not-set') },
          ],
        },
      },
    },
    {
      ...(isInLiveMode && {
        title: i18n.t('video-settings'),
        schema: {
          video: {
            ...replaceVideo,
            label: i18n.t('video-trailer'),
            options: {
              type: 'video',
            },
          },
        },
      }),
    },
    {
      title: i18n.t('display-settings'),
      schema: {
        cover_art: {
          ...cover_art,
          options: {
            type: 'image',
          },
        },
      },
    },
    {
      title: i18n.t('additional_details-settings'),
      schema: getVideoAdminPropertiesAdditionalDetailsSchema({ adminSettings, isInLiveMode }),
    },
    {
      title: i18n.t('social-settings'),
      schema: {
        community_enabled: {
          ...community_enabled,
          options: [
            {
              value: true,
              label: i18n.t('q_and_a-enabled'),
            },
            {
              value: false,
              label: i18n.t('q_and_a-disabled'),
            },
          ],
        },
        ...(isInLiveMode && {
          tribe_chat_enabled: {
            ...tribe_chat_enabled,
            options: [
              {
                value: true,
                label: i18n.t('chat-enabled'),
              },
              {
                value: false,
                label: i18n.t('chat-disabled'),
              },
            ],
          },
        }),
      },
    },
    {
      title: i18n.t('custom_fields-settings'),
      schema: getVideoAdminPropertiesCustomFieldsSchema({ adminSettings }),
    },
    {
      title: i18n.t('catalog'),
      schema: {
        exclude_from_search: {
          ...exclude_from_search,
          options: [
            { value: true, label: i18n.t('active') },
            { value: false, label: i18n.t('not-set') },
          ],
        },
        [topicsKey]: {
          ...topicsMap[topicsKey],
          options: {
            delimiter: ' > ',
            labelKey: 'name',
          },
        },
        summary,
      },
    },
    {
      title: i18n.t('tagging-settings'),
      schema: {
        tags: {
          ...tags,
          label: i18n.t('tags'),
          options: {
            delimiter: ', ',
            labelKey: 'name',
          },
        },
      },
    },
    {
      title: i18n.t('seo_properties-settings'),
      schema: getVideoAdminPropertiesSeoPropertiesSchema({ id }),
    },
  ];
};
